import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { usePanning } from '../../hooks/usePanning.js';
import { cssVar } from '../../theme/variables.js';
import { motion } from 'framer-motion';
import React__default from 'react';
import { styled } from 'styled-components';

const Base = styled(motion.div).withConfig({
  displayName: "Drawer__Base",
  componentId: "sc-7ac431ff-0"
})([
  `background:`,
  `;padding-top:1rem;padding-bottom:max( calc(1rem + env(safe-area-inset-bottom)),calc(var(--keyboard-height,0px) + 1rem) );z-index:1;height:max-content;max-height:calc(100dvh - env(safe-area-inset-top,0px));border-radius:2rem 2rem 0 0;will-change:transform;position:relative;display:flex;flex-direction:column;&:before{content:'';position:absolute;display:block;height:80px;width:100%;bottom:calc(100% - 40px);left:0;}`
], cssVar["color-bg-primary"]);
const Outside = styled.div.withConfig({
  displayName: "Drawer__Outside",
  componentId: "sc-7ac431ff-1"
})([
  `position:absolute;left:0;bottom:calc(100% - 40px);height:calc(100vh + 40px);z-index:-1;width:100%;pointer-events:auto;`
]);
const Drawer = ({ children, onOpenChange, className, panningLayerId, onOffsetYChange, onPanEnd: onPanEndProp, style }) => {
  const [panCloseOffset, setPanCloseOffset] = React__default.useState(0);
  const onPanEnd = React__default.useCallback((e, info, moreInfo) => {
    const { velocity, offset } = info;
    if (velocity.y > 50) {
      onOpenChange(false);
      onPanEndProp?.(e, info, {
        ...moreInfo,
        shouldClose: true
      });
      setPanCloseOffset(offset.y);
      return;
    } else {
      onPanEndProp?.(e, info, {
        ...moreInfo,
        shouldClose: false
      });
    }
  }, [
    onOpenChange,
    onPanEndProp
  ]);
  const { motionProps, panningYOffset } = usePanning({
    onPan: (e, info) => {
      onOffsetYChange?.(info.offset.y);
    },
    onPanEnd,
    panningLayerId
  });
  const handleEventClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onOpenChange(false);
  };
  const handleEventCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs(Base, {
      className,
      style: {
        transform: `translateY(${panCloseOffset || Math.max(panningYOffset, 0)}px)`,
        transition: panningYOffset < 0 ? "none" : "transform 0.2s cubic-bezier(0.165, 0.84, 0.44, 1)",
        ...style
      },
      ...motionProps,
      children: [
        /* @__PURE__ */ jsx(Outside, {
          /**
          * Prevent pointer events from leaking through by capturing
          * both pointerdown and pointerup on the overlay
          *
          * this works with pointer device only, not touch screen
          */
          onPointerDown: (eDown) => {
            handleEventCancel(eDown);
            const handlePointerUp = (eUp) => {
              if (eDown.target !== eUp.target || eDown.button !== eUp.button) {
                return;
              }
              handleEventCancel(eUp);
              setTimeout(() => {
                onOpenChange(false);
              }, 10);
            };
            window.addEventListener("pointerup", handlePointerUp, {
              once: true,
              capture: true
            });
          },
          /**
          * special treatment with touch screen
          */
          onTouchStart: handleEventCancel,
          onTouchEnd: handleEventClose
        }),
        children
      ]
    })
  });
};

export { Drawer };
//# sourceMappingURL=Drawer.js.map
